var exports = {
  "dc": "ReferralSettingsTab.module__spinnerContainer___d0FuOW",
  "Zp": "ReferralSettingsTab.module__layout___d0FuOW",
  "M1": "ReferralSettingsTab.module__stats___d0FuOW",
  "dJ": "ReferralSettingsTab.module__stat___d0FuOW",
  "cR": "ReferralSettingsTab.module__statValue___d0FuOW",
  "Zh": "ReferralSettingsTab.module__statLabel___d0FuOW",
  "p_": "ReferralSettingsTab.module__list___d0FuOW",
  "nM": "ReferralSettingsTab.module__row___d0FuOW",
  "uV": "ReferralSettingsTab.module__rowHeader___d0FuOW",
  "G9": "ReferralSettingsTab.module__rowTitle___d0FuOW",
  "en": "ReferralSettingsTab.module__rowMeta___d0FuOW",
  "h3": "ReferralSettingsTab.module__rowReached___d0FuOW",
  "M0": "ReferralSettingsTab.module__bar___d0FuOW",
  "pP": "ReferralSettingsTab.module__barFill___d0FuOW",
  "Ie": "ReferralSettingsTab.module__empty___d0FuOW",
};

module.exports = exports;
